import { emailSnippetsApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

const emailSnippetsSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const EMAIL_SNIPPETS_ACTION_TYPE = createNamedActions('emailSnippets', {
  SET_ACTIVE_SNIPPET: 'SET_ACTIVE_SNIPPET',
  GET_EMAIL_SNIPPETS: 'GET_EMAIL_SNIPPETS',
  CREATE_EMAIL_SNIPPET: 'CREATE_EMAIL_SNIPPET',
  UPDATE_EMAIL_SNIPPET: 'UPDATE_EMAIL_SNIPPET',
  DELETE_EMAIL_SNIPPET: 'DELETE_EMAIL_SNIPPET',
  GET_EMAIL_SNIPPET_PREVIEW: 'GET_EMAIL_SNIPPET_PREVIEW',
});

export const setActiveSnippetAction = snippetData => ({
  type: EMAIL_SNIPPETS_ACTION_TYPE.SET_ACTIVE_SNIPPET,
  payload: snippetData,
});

export const getEmailSnippetsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await emailSnippetsApi.getEmailSnippets(params);

  return dispatch({
    type: EMAIL_SNIPPETS_ACTION_TYPE.GET_EMAIL_SNIPPETS,
    payload: normalize(data, [emailSnippetsSchema]).entities.data,
  });
});

export const createEmailSnippetAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await emailSnippetsApi.createEmailSnippet(params);

  return dispatch({
    type: EMAIL_SNIPPETS_ACTION_TYPE.CREATE_EMAIL_SNIPPET,
    payload: data,
  });
});

export const updateEmailSnippetAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await emailSnippetsApi.updateEmailSnippet(params);

  return dispatch({
    type: EMAIL_SNIPPETS_ACTION_TYPE.UPDATE_EMAIL_SNIPPET,
    payload: data,
  });
});

export const deleteEmailSnippetAction = catchAsyncActionError(params => async dispatch => {
  await emailSnippetsApi.deleteEmailSnippet(params);

  return dispatch({
    type: EMAIL_SNIPPETS_ACTION_TYPE.DELETE_EMAIL_SNIPPET,
    meta: params,
  });
});

export const getEmailSnippetPreviewAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await emailSnippetsApi.getEmailSnippetPreview(params);

  return dispatch({
    type: EMAIL_SNIPPETS_ACTION_TYPE.GET_EMAIL_SNIPPET_PREVIEW,
    payload: data,
  });
});
